var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradingCompDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3782_2065",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1650",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3782_2065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 654",
    d: "M13.5984 8.46542L11.8573 5.75342H9.28079M13.5984 8.46542H10.4926M13.5984 8.46542L7.97491 14.1534M2.39844 8.46542L4.02197 5.75342H6.6102M2.39844 8.46542H5.48079M2.39844 8.46542L7.97491 14.1534M6.6102 5.75342L5.48079 8.46542M6.6102 5.75342H9.28079M5.48079 8.46542H10.4926M5.48079 8.46542L7.97491 14.1534M9.28079 5.75342L10.4926 8.46542M10.4926 8.46542L7.97491 14.1534",
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 655",
    d: "M8 3.23343V1.6001",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 656",
    d: "M9.86302 3.80806L10.6797 2.39355",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 658",
    d: "M12.1966 4.57486L13.3516 3.41992",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 659",
    d: "M3.55338 4.57486L2.39844 3.41992",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 657",
    d: "M6.01589 3.80806L5.19922 2.39355",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingCompDiamond);
export default __webpack_public_path__ + "static/media/tradingCompDiamond.e5bbf98ddfc2600f162e15338daea14e.svg";
export { ForwardRef as ReactComponent };